import MainService from "@/services/MainService.js";
import dataTable from "@/components/Datatable";
import Loader from "@/components/Loader";
window.$ = window.jQuery = require("jquery");

export default {
    name: "ConceptoSPPage",
    data() {
        let ss = new MainService();
        return {
            msg: "ConceptoSPPage",
            ss: ss,
            auth: {},

            ajax: {
                "url": ss.indexConceptoSP(),
                headers: ss.getToken(),
            },
            columns: [
                { data: 'id', name: 'id', orderable: false, searchable: false, visible: false },
                { data: 'DT_RowIndex', name: 'DT_RowIndex', title: 'N', orderable: false, searchable: false },
                { data: 'Grupo', name: 'Grupo', title: 'Grupo' },
                { data: 'Sigla', name: 'Sigla', title: 'Sigla' },
                { data: 'ConceptoSP', name: 'ConceptoSP', title: 'Concepto' },
                { data: 'Codigo', name: 'Codigo', title: 'Código' },
                { data: 'Descripcion', name: 'Descripcion', title: 'Descripción' },
                { data: 'Grupo', name: 'Grupo', title: 'Grupo' },
                { data: 'Activo', name: 'sc.Activo', title: 'Estado', render:function(data, type, row){
                    if (!row.Activo){ return '<i class="fa fa-ban text-danger"></i>'; }
                    else{ return '<i class="fa fa-check text-success"></i>'; }
                }},
                {
                    data: 'action',
                    orderable: false,
                    title: 'Acciones',
                    searchable: false
                },
            ],
            rols: [],
            conceptosps: [],
            isLoading: false,
            isLoadingFile: false,
            errorBag: {},
            conceptosp: {},
            
        };
    },
    methods: {
      
        newConceptoSP() {
            this.conceptosp = {};
            this.$refs['frm-conceptosp'].show();
            // console.log("hhhhola")
        },
        showConceptoSP(id) {
            this.isLoading=true;
            this.ss.showConceptoSP(id).then(
                (result) => {
                    let response = result.data;
                    this.conceptosp = response.data;
                    this.$refs['view-conceptosp'].show();
                    this.isLoading=false;
                }
            ).catch(error => {
                console.log(error);
                this.isLoading=false;
            });
        },
        editConceptoSP() {
            this.$refs['frm-conceptosp'].show();
            this.$refs['view-conceptosp'].hide();
        },
        cancelConceptoSP() {
            if (this.conceptosp.id) {
                this.$refs['view-conceptosp'].show();
            }
            this.$refs['frm-conceptosp'].hide();
        },
        saveConceptoSP() {
            this.ss.storeConceptoSP(this.conceptosp).then(
                (result) => {
                    console.log(result);
                    let response = result.data;
                    this.$bvToast.toast(
                        response.msg,
                        {
                            title: 'Correcto',
                            variant: 'success',
                            autoHideDelay: 5000
                        }
                    )
                    //this.$refs['view-consulta'].show(); //para volver al modal
                    console.log(response);
                    this.$refs['frm-conceptosp'].hide();
                    this.$refs['datatable-conceptosp'].reload();
                })
                .catch((error) => {
                    this.errorBag = error.response.data.errors;
                    console.log(error.response.data);
                    this.$bvToast.toast(
                        'Problema al Guardar el Registro, favor verificar los Datos',
                        {
                            title: 'Error',
                            variant: 'danger',
                            autoHideDelay: 5000
                        }
                    )
                });
        },
        deleteConceptoSP() {
            this.$swal({
                title: "Estas seguro que deseas eliminar?",
                text: "Esta accion es irreversible!",
                icon: "warning",
                buttons: true,
                dangerMode: true,
                showCancelButton: true,
                cancelButtonColor: '#d33',
            })
                .then((willDelete) => {
                    if (willDelete.isConfirmed) {
                        this.ss.destroyConceptoSP(this.conceptosp)
                            .then((result) => {
                                let response = result.data;
                                console.log(response);
                                this.$bvToast.toast(
                                    response.msg,
                                    {
                                        title: 'Correcto',
                                        variant: 'success',
                                        autoHideDelay: 5000
                                    }
                                )
                                this.$refs['view-conceptosp'].hide();
                                this.$refs['datatable-conceptosp'].reload();
                            })
                            .catch(error => {
                                console.log(error);
                            })
                    } else {
                        //swal("Your imaginary file is safe!");
                    }
                });
        },
        cambiopassword() {
            this.$refs['view-conceptosp'].hide();
            this.$refs['view-password'].show();
        },
        cancelPassword() {
            this.$refs['view-password'].hide();
            this.$refs['view-conceptosp'].show();
        },
        changePassword() {
            this.password.ConceptoSP = this.conceptosp.id;
            this.ss.changePassword(this.password)
                .then( result => {
                    let response = result.data;
                    if ( response.success ) {
                        this.$bvToast.toast(
                            response.msg,
                            {
                                title: 'Correcto',
                                variant: 'success',
                                autoHideDelay: 5000
                            }
                        )
                        this.$refs['view-password'].hide();
                        this.$refs['view-conceptosp'].show();
                    } else {
                        this.$bvToast.toast(
                            response.msg,
                            {
                                title: 'Oops',
                                variant: 'danger',
                                autoHideDelay: 5000
                            }
                        )
                    }
                })
                .catch( error => {
                    console.log( error );
                    this.$bvToast.toast(
                        'Error al guardar el registro',
                        {
                            title: 'Oops',
                            variant: 'danger',
                            autoHideDelay: 5000
                        }
                    )
                    this.errorBag = error.data.errors;
                })
        },
        draw() {
            window.$('.btn-datatable-ConceptoSP').on('click', (evt) => {
                const data = window.$(evt.target)[0].id;
                this.showConceptoSP(data);
            });
        }
    },
    components: {
        dataTable,
        Loader
    },
    mounted() {
        
        var persona = JSON.parse(localStorage.getItem('persona'));
        this.auth = JSON.parse(localStorage.getItem("persona"));
        if (!persona) {
            this.$router.push('/Login');
        } 
    }
};
